import ChannelPreview from './ChannelPreview';

export default ChannelPreview;
